import type {CSSProperties} from 'react';
import {wedgeExactRole as r} from './wedgeRoles.js';

export type WedgeBriefRailLook = 'briefrail-action' | 'briefrail-primary';
export const isWedgeBriefRailLook = (look: string): look is WedgeBriefRailLook => look === 'briefrail-action' || look === 'briefrail-primary';

// The desktop rail retains its shipped off-scale geometry and native disabled state.
export function wedgeBriefRailStyle(look: WedgeBriefRailLook, disabled: boolean): CSSProperties {
  const primary = look === 'briefrail-primary';
  return {
    display: 'flex', alignItems: 'center', gap: 10, width: '100%',
    padding: '11px 12px', borderRadius: 11, cursor: disabled ? 'default' : 'pointer',
    background: r(primary ? 'accent' : 'bgElev'), color: r(primary ? 'onAccent' : 'label'),
    border: primary ? 'none' : `0.5px solid ${r('separator')}`,
    fontFamily: r('font'), fontSize: 14, fontWeight: 600, textAlign: 'left', opacity: disabled ? 0.5 : 1,
  };
}
